export const experimentUrlSuffix = '-v2';

export const toExperimentUrl = (url: string): string => {
  const parsedUrl = new URL(url, 'https://example.com');

  const segments = parsedUrl.pathname.split('/');
  segments[1] = `${segments[1]}${experimentUrlSuffix}`;
  parsedUrl.pathname = segments.join('/');

  return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
};

export const isExperimentUrl = (url: string | undefined): boolean => {
  if (!url) {
    return false;
  }

  const parsedUrl = new URL(url, 'https://example.com');
  return (
    parsedUrl.pathname.split('/')[1]?.endsWith(experimentUrlSuffix) ?? false
  );
};
